module.exports = __webpack_public_path__ + "static/media/Banner.340ae76a.svg";